import { useState } from 'react';
import { api } from '../api.js';
import { t, huidigeTaal, zetTaal, zetThema, TALEN } from '../i18n.js';
import { ICOON } from '../components/iconen.jsx';

const THEMAS = [['systeem', 'Systeem'], ['licht', 'Licht'], ['donker', 'Donker']];

/**
 * Instellingen: alleen voor jou, en ze gaan mee naar elke computer waarop je je aanmeldt. Zie
 * docs/besluiten/instellingen-per-medewerker.md.
 */
export default function Instellingen({ mij, opnieuw }) {
  const [thema, zetKeuze] = useState(mij.settings.theme);

  const kiesThema = async (k) => {
    zetKeuze(k);
    zetThema(k);
    await api.zetInstellingen({ theme: k }).catch(() => {});
    opnieuw();
  };
  const kiesTaal = async (code) => {
    if (code === huidigeTaal()) return;
    zetTaal(code);
    await api.zetInstellingen({ language: code }).catch(() => {});
    window.location.reload();
  };

  return (
    <>
      <section className="setblok">
        <span className="label blokkop"><span className="blokicoon">{ICOON.schuif}</span>{t('Weergave')}</span>
        <div className="setrij">
          <div className="setkop"><b>{t('Thema')}</b><span>{t('Volgt je systeem tenzij je kiest')}</span></div>
          <div className="themarij">
            {THEMAS.map(([k, l]) => (
              <button key={k} type="button" className="themaknop" aria-pressed={thema === k} onClick={() => kiesThema(k)}>
                {ICOON[k]}<span>{t(l)}</span>
              </button>
            ))}
          </div>
        </div>
        <div className="setrij">
          <div className="setkop"><b>{t('Taal')}</b><span>{t('Van de werkplek en de SOC-schermen die je hier opent. Wat ADTS ZERO aan klanten stuurt, volgt de taal van de klant.')}</span></div>
          <div className="themarij">
            {Object.entries(TALEN).map(([code, naam]) => (
              <button key={code} type="button" className="themaknop" aria-pressed={huidigeTaal() === code} onClick={() => kiesTaal(code)}>
                <span className="kort">{code.toUpperCase()}</span><span>{naam}</span>
              </button>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
